import api from '@/common/api';
import applyStatusHelper from '@/common/applyStatusHelper';
import RouteKey from '@/common/RouteKey';
import MessageType from '@/components/common/message-box/MessageType';
import DescriptionFolder from '@/components/common/DescriptionFolder';
import SubMenu from '../common/SubMenu';
import FormItemUploadFile from '../common/FormItemUploadFile';
import { KeyEnum, DisplayMapper } from '@/common/OptionConstant';
import DateUtils from '@/common/DateUtils';
import DeviceUtils from '@/common/utils/DeviceUtils';
import ErrorHandler from './ErrorHandler';
import PasswordAdd from '../common/PasswordAdd';
const DateFormat = DateUtils.DateFormat;

const ApplyType = {
  TEST: 1,
  PRO: 2
};
const DeviceStatus = {
  INACTIVE: 1
};
const limittypes = {
  1: 'QPS',
  2: 'DOCKER',
  3: 'NUM',
  4: 'GPU',
  5: 'SKU'
};
const IS_SUCCESS = 'is-success';
const IS_ERROR = 'is-error';
const LIST_NUM = 100;
const PLAT_SERVER = 64;
const SHOW_SDK_1 = 'YtOpen';
const SERVICE_TYPE = 'service/centos';

const MAX_HA_DEVICE_NUM = 11;

export default {
  name: 'PrivateDisplayer',
  components: {
    DescriptionFolder,
    FormItemUploadFile,
    SubMenu,
    PasswordAdd
  },
  data() {
    return {
      ErrorName: 'GROUPDEVICE',
      ErrorNameText: 'INFO',
      DeviceInfoErrorName: 'DEVICE_INFO_ERROR',
      validateGroupDeviceFileResultContract: false,
      validateFileDevice: false,
      validateFileContract: false,
      validateFileDeviceInfo: false,
      RouteKey,
      privateList: [],
      applyStatusHelper,
      loaded: false,
      addMainBackVisible: false,
      addDeviceVisible: false,
      groupAddDeviceVisible: false,
      contractFormalVisible: false,
      dialogContractText: '',
      dialogContractTitle: '',
      JoinWay: KeyEnum.JoinWay,
      privateServeToFomal: '',
      addDeviceNoData: {
        devno: '',
        remark: ''
      },
      addDeviceFingerprintData: {
        fingerprint: '',
        remark: ''
      },
      groupDeviceFiles: null,
      dialogContractFiles: null,
      bindDevicePrivateItem: null,
      gpuBindInfo: [],
      productList: [],
      svcList: [],
      svcListGPU: {},
      svcListInstance: {},
      DisplayMapper,
      privateApplyKeyType: KeyEnum.PrivateApplyType,
      PrivateStatusKey: KeyEnum.PrivateApplyStatus,
      ApplyType,
      DeviceAuth: KeyEnum.DeviceAuth,
      DeviceStatus,
      renewalVisible: false,
      renewalVisibleFile: true,
      renewalValidateForm: {
        demand: ''
      },
      mailReceiverVisible: false,
      mailReceiverData: {
        receiver: ''
      },
      rulesReceiver: {
        receiver: [{
          type: 'string',
          required: true,
          message: '邮箱不能为空',
          trigger: ['blur, change']
        }, {
          max: 500,
          message: '不超过500字'
        }, {
          validator: ErrorHandler.validateMail,
          trigger: ['change', 'blur']
        }]
      },
      rulesRenewal: {
        demand: [{
          required: true,
          validator: ErrorHandler.validateDemand,
          trigger: ['change', 'blur']
        }]
      },
      mailEditingItem: {},
      deviceShow: true,
      deviceGroupShow: false,
      deviceInfoShow: false,
      deviceInfoVisible: false,
      deviceFingerprintShow: false,

      mainBackMode: true,
      highAvailabilityMode: false,

      mainBackData: {
        configMode: 'DeviceInfo',
        mainip: '',
        mainMD5: '',
        mainFileValidateResult: {
          validate: false,
          file: null,
          isVaild: false
        },
        backip: '',
        backMD5: '',
        backFileValidateResult: {
          validate: false,
          file: null,
          isVaild: false
        }
      },

      highAvailabilityData: {
        configMode: 'DeviceInfo',
        CenterBindInfoPair: [
          {
            key: '1',
            ip: '',
            md5: '',
            validate: false,
            file: null,
            isVaild: false
          },
          {
            key: '2',
            ip: '',
            md5: '',
            validate: false,
            file: null,
            isVaild: false
          },
          {
            key: '3',
            ip: '',
            md5: '',
            validate: false,
            file: null,
            isVaild: false
          }
        ]
      },

      deviceInfoData: {
        remark: ''
      },
      validateDeviceInfoFileResult: {
        file: null,
        isVaild: false
      },
      validateGroupDeviceFileResult: {
        file: null,
        isVaild: false
      },
      remarksData: {
        id: '',
        appid: '',
        devno: '',
        remark: ''
      },
      remarksVisible: false,
      addShow: false
    };
  },
  computed: {
    disabledAddHADevice() {
      return this.highAvailabilityData.CenterBindInfoPair.length >= MAX_HA_DEVICE_NUM;
    }
  },
  methods: {
    showHAMode(PrivateItem) {
      if (!PrivateItem) {
        return false;
      }
      // 非高性能模式
      if (!PrivateItem.is_ha_mode || !PrivateItem.bind_ha_mode) {
        return false;
      }
      const devices = PrivateItem.devices.filter((device) => !!device.devno);
      // 高性能模式，但有设备未激活
      if (devices.find((device) => device.status !== DeviceStatus.INACTIVE)) {
        return false;
      }
      // 高性能模式，但没有设备
      if (!devices.map((device) => device.devno).length) {
        return false;
      }
      return true;
    },
    resetmailReceiverForm() {
      this.mailReceiverVisible = false;
      this.$refs.mailReceiverForm.resetFields();
    },
    showMailReceiverVisible(privateItem) {
      if (privateItem.mailreceiver.length > 0) {
        this.mailReceiverData.receiver = privateItem.mailreceiver;
      }
      this.mailEditingItem = privateItem;
      this.mailReceiverVisible = true;
    },
    submitChangeMailReceiver() {
      this.$refs.mailReceiverForm.validate((valid) => {
        if (valid) {
          this.mailReceiverVisible = false;
          const loading = this.loading();
          let mailreceiver = this.mailReceiverData.receiver;
          mailreceiver = mailreceiver.replace(/;/g, ',');
          mailreceiver = mailreceiver.replace(/；/g, ',');
          let data = {
            id: this.mailEditingItem.id,
            mailreceiver: mailreceiver
          };
          this.$loader.post(api.ytprivate.MAIL, data, this.ajaxErrorCallback).then(() => {
            this.getAllPrivate();
          }).finally(() => {
            this.mailEditingItem.mailreceiver = mailreceiver;
            this.resetmailReceiverForm();
            loading.close();
          });
        }
      });
    },
    validateIPAddress(rule, value, callback) {
      let reg = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/;
      if (value === '') {
        return callback(new Error('请输入IP地址'));
      }
      if (value && !reg.test(value)) {
        return callback(new Error('IP地址不规范'));
      } else {
        callback();
      }
    },
    validateMD5(rule, value, callback) {
      let reg = /^[-:a-zA-Z0-9_]+$/;
      if (value === '') {
        return callback(new Error('请输入设备指纹'));
      }
      if (value && !reg.test(value)) {
        return callback(new Error('设备指纹不规范'));
      } else {
        callback();
      }
    },
    validateDevno(rule, value, callback) {
      let reg = /^[-:a-zA-Z0-9_]+$/;
      if (value === '') {
        return callback(new Error('请输入设备号'));
      }
      if (!reg.test(value)) {
        return callback(new Error('设备号格式错误，请输入数字、字母、英文冒号或-'));
      }
      callback();
    },
    validateFingerprint(rule, value, callback) {
      let reg = /^[-:a-zA-Z0-9_]+$/;
      if (value === '') {
        return callback(new Error('请输入设备指纹'));
      }
      if (!reg.test(value)) {
        return callback(new Error('设备号格式错误，请输入数字、字母、英文冒号或-'));
      }
      callback();
    },
    // 验证备注
    validateRemarks(rule, value, callback) {
      if (value === '') {
        return callback(new Error('备注不能为空'));
      }
      if (value.indexOf('%') !== -1) {
        return callback(new Error('备注格式错误，不支持%'));
      }
      callback();
    },
    configDeviceInfoValidateResult(data, mode, conf) {
      if (mode === 'MBMode') {
        let classItems = this.$refs[`${conf}DeviceInfoFile`].$el.classList;
        this.handleValidateUploadResult(data, classItems, this.mainBackData[`${conf}FileValidateResult`]);
      } else {
        let classItems = this.$refs[`HADeviceInfoFile_${conf}`][0].$el.classList;
        const index = this.highAvailabilityData.CenterBindInfoPair.findIndex(item => item.key === conf);
        index > -1 && this.handleValidateUploadResult(data, classItems, this.highAvailabilityData.CenterBindInfoPair[index]);
      }
    },
    deviceValidateResult(data) {
      let classItems = this.$refs.deviceGroupFile.$el.classList;
      this.handleValidateUploadResult(data, classItems, this.validateGroupDeviceFileResult);
    },
    deviceInfoValidateResult(data) {
      let classItems = this.$refs.deviceInfoFile.$el.classList;
      this.handleValidateUploadResult(data, classItems, this.validateDeviceInfoFileResult);
    },
    handleValidateUploadResult(data, classItems, filesResult) {
      if (data.result === true || data.file != null) {
        classItems.add(IS_SUCCESS);
        classItems.remove(IS_ERROR);
        filesResult.isVaild = data.result;
        filesResult.file = data.file;
        return;
      }
      classItems.add(IS_ERROR);
      classItems.remove(IS_SUCCESS);
      filesResult.file = null;
      filesResult.isVaild = false;
    },
    handleValidateUploadResultContract(data) {
      let classItems = this.$refs.formalPrivate.$el.classList;
      if (data.result === true || data.file != null) {
        classItems.add(IS_SUCCESS);
        classItems.remove(IS_ERROR);
        this.validateGroupDeviceFileResultContract = data.result;
        this.dialogContractFiles = data.file;
        return;
      }
      classItems.add(IS_ERROR);
      classItems.remove(IS_SUCCESS);
      this.dialogContractFiles = null;
      this.validateGroupDeviceFileResultContract = false;
    },
    handleDeletePrivate(id) {
      this.$confirm('确定删除该私有云服务?', '提示', MessageType.INFO).then(() => {
        this.$loader.post(api.ytprivate.REMOVE_YTPRIVATE, {id: id}, this.ajaxErrorCallback).then(() => {
          this.getAllPrivate();
          this.$alert('删除私有云服务成功', null, MessageType.SUCCESS);
        });
      });
    },
    handleChangeToFormalPrivate(privateItem) {
      this.contractFormalVisible = true;
      if (privateItem.scope === KeyEnum.JoinWay.INTERNAL) {
        this.dialogContractText = '合作备案';
        this.dialogContractTitle = '合作备案';
      } else {
        this.dialogContractText = '合同文件';
        this.dialogContractTitle = '合同文件';
      }
      this.privateServeToFomal = privateItem;
    },
    handleApplyRenewalPrivate(privateItem) {
      this.contractFormalVisible = true;
      this.renewalVisible = true;
      this.dialogContractTitle = '续期需求';
      if (privateItem.scope === KeyEnum.JoinWay.INTERNAL) {
        this.dialogContractText = '合作备案';
      } else {
        this.dialogContractText = '合同文件';
      }
      if (parseInt(privateItem.applytype) === parseInt(this.privateApplyKeyType.TEST)) {
        this.renewalVisibleFile = false;
      }
      if (((privateItem.status & this.PrivateStatusKey.FORMAL_VERIFY_FAIL) === this.PrivateStatusKey.FORMAL_VERIFY_FAIL) &&
        privateItem.status !== this.PrivateStatusKey.FORMAL_VERIFY_FAIL &&
        privateItem.isrenewal !== 1) {
        this.renewalVisibleFile = false;
      }
      this.privateServeToFomal = privateItem;
    },
    confirmApplyAuth() {
      this.validateFileContract = !(this.validateFileContract);
      if (this.validateGroupDeviceFileResultContract === false) {
        return;
      }
      this.doSumbitApply();
    },
    confirmRenewalAuth() {
      if (this.renewalVisibleFile) {
        this.validateFileContract = !(this.validateFileContract);
        this.$refs.contractForm.validate((valid) => {
          if (valid && this.validateGroupDeviceFileResultContract !== false) {
            this.doSumbitApply();
          }
        });
        return;
      }
      this.$refs.contractForm.validate((valid) => {
        if (valid) {
          this.doSumbitApply();
        }
      });
    },
    doSumbitApply() {
      const loading = this.loading();
      let data = {
        id: this.privateServeToFomal.id,
        applytype: this.privateServeToFomal.applytype
      };
      if (((this.privateServeToFomal.status & this.PrivateStatusKey.FORMAL_VERIFY_FAIL) === this.PrivateStatusKey.FORMAL_VERIFY_FAIL) &&
        this.privateServeToFomal.status !== this.PrivateStatusKey.FORMAL_VERIFY_FAIL &&
        this.privateServeToFomal.isrenewal !== 1) {
        data.applytype = ApplyType.TEST;
      }
      let file = null;
      let url = api.ytprivate.PRODUCTIZE_AUTH;
      if (this.renewalVisible) {
        data.renewaldemand = this.renewalValidateForm.demand;
        url = api.ytprivate.RENEWAL;
      }
      if (this.renewalVisibleFile) {
        file = {
          contract: this.dialogContractFiles
        };
      }
      this.$loader.upload(url, data, file, this.ajaxErrorCallback).then(() => {
        this.contractFormalVisible = false;
        this.getAllPrivate();
      }).finally(() => {
        this.cancleContractForm();
        loading.close();
      });
    },
    // 删除设备
    handleDeleteDevice(privateItem, deviceItem) {
      if (deviceItem.status !== DeviceStatus.INACTIVE) {
        let data = {
          id: privateItem.id,
          devno: deviceItem.devno
        };
        this.$confirm('确认删除该设备', '提示', MessageType.INFO).then(() => {
          const loading = this.loading();
          this.$loader.post(api.ytprivate.REMOVE_DEVICE, data, this.ajaxErrorCallback).then(() => {
            loading.close();
            this.getAllPrivate();
          }).finally(() => {
            loading.close();
          });
        });
      }
    },

    // 手动绑定-添加设备
    handleDevice() {
      this.deviceShow = true;
      this.deviceGroupShow = false;
      this.deviceInfoShow = false;
      this.deviceFingerprintShow = false;
      this.svcListGPU = {};
      this.svcListInstance = {};
      this.cancleBindDeviceInfo();
      this.cancleBindGroupDevice();
      if (this.$refs.deviceInfoData) {
        this.$refs.deviceInfoData.resetFields();
      }
      if (this.$refs.addDeviceFingerprintData) {
        this.$refs.addDeviceFingerprintData.resetFields();
      }
    },

    // 批量添加设备
    handleGroupDevice() {
      this.deviceShow = false;
      this.deviceGroupShow = true;
      this.deviceInfoShow = false;
      this.deviceFingerprintShow = false;
      this.groupAddDeviceVisible = true;
      this.svcListGPU = {};
      this.svcListInstance = {};
      this.cancleBindDeviceInfo();
      if (this.$refs.addDeviceNoData) {
        this.$refs.addDeviceNoData.resetFields();
      }
      if (this.$refs.deviceInfoData) {
        this.$refs.deviceInfoData.resetFields();
      }
      if (this.$refs.addDeviceFingerprintData) {
        this.$refs.addDeviceFingerprintData.resetFields();
      }
    },

    // 添加设备信息
    handleDeviceInfo() {
      this.deviceShow = false;
      this.deviceGroupShow = false;
      this.deviceFingerprintShow = false;
      this.deviceInfoShow = true;
      this.deviceInfoVisible = true;
      this.svcListGPU = {};
      this.svcListInstance = {};
      this.cancleBindGroupDevice();
      if (this.$refs.addDeviceNoData) {
        this.$refs.addDeviceNoData.resetFields();
      }
      if (this.$refs.deviceInfoData) {
        this.$refs.deviceInfoData.resetFields();
      }
      if (this.$refs.addDeviceFingerprintData) {
        this.$refs.addDeviceFingerprintData.resetFields();
      }
    },
    handleDeviceFingerprint() {
      this.deviceShow = false;
      this.deviceGroupShow = false;
      this.deviceFingerprintShow = true;
      this.deviceInfoShow = false;
      this.deviceInfoVisible = false;
      this.svcListGPU = {};
      this.svcListInstance = {};
      this.cancleBindGroupDevice();
      this.cancleBindDeviceInfo();
      if (this.$refs.addDeviceNoData) {
        this.$refs.addDeviceNoData.resetFields();
      }
      if (this.$refs.deviceInfoData) {
        this.$refs.deviceInfoData.resetFields();
      }
    },
    handleCenterDeviceInfo() {
      this.mainBackMode = true;
      this.highAvailabilityMode = false;
    },
    handlecenterDeviceFingerprint() {
      this.highAvailabilityMode = true;
      this.mainBackMode = false;
    },
    /**
     * 高性能模式下，动态添加高可用设备信息
     */
    addHADeviceFormItem() {
      const mayNum = MAX_HA_DEVICE_NUM - this.highAvailabilityData.CenterBindInfoPair.length;
      let defualtAddNum = 2;
      if (mayNum < defualtAddNum) {
        defualtAddNum = mayNum;
      }
      if (defualtAddNum === 0) {
        return;
      }
      const newFormItems = new Array(defualtAddNum).fill(0).map((_, index) => ({
        key: `${Date.now().toString()}_${index}`,
        ip: '',
        md5: '',
        validate: false,
        file: null,
        isVaild: false
      }));
      this.highAvailabilityData.CenterBindInfoPair.push(...newFormItems);
    },
    /**
     * 高性能模式下，动态删除高可用设备信息
     */
    deleteHADeviceFormItem(index) {
      this.$delete(this.highAvailabilityData.CenterBindInfoPair, index);
    },
    /**
     * 主备模式下，校验主备设备信息
     */
    validateBindMainBackDeviceConfig() {
      if (this.mainBackData.configMode === 'DeviceInfo') {
        this.$set(this.mainBackData.mainFileValidateResult, 'validate', true);
        this.$set(this.mainBackData.backFileValidateResult, 'validate', true);
      }
      this.$refs.mainBackData.validate((valid) => {
        if (!valid) {
          return;
        }
        if (this.mainBackData.configMode === 'DeviceInfo' && (this.mainBackData.mainFileValidateResult.isVaild === false || this.mainBackData.backFileValidateResult.isVaild === false)) {
          return;
        }
        if (this.mainBackData.mainip === this.mainBackData.backip) {
          this.$alert('主备服务器IP不能相同');
          return;
        }
        this.addMainBackVisible = false;
        this.doSumbitMainBackInfo();
      });
    },
    /**
     * 高可用模式下，校验高可用设备信息
     */
    validateBindHADeviceConfig() {
      if (this.highAvailabilityData.CenterBindInfoPair.length % 2 !== 1 || this.highAvailabilityData.CenterBindInfoPair.length > MAX_HA_DEVICE_NUM) {
        this.$alert('高可用设备节点数量必须是奇数，且不超过' + MAX_HA_DEVICE_NUM + '个');
        return;
      }
      if (this.highAvailabilityData.configMode === 'DeviceInfo') {
        this.highAvailabilityData.CenterBindInfoPair.forEach((item, index) => {
          this.$set(this.highAvailabilityData.CenterBindInfoPair[index], 'validate', true);
        });
      }
      this.$refs.highAvailabilityData.validate((valid) => {
        if (!valid) {
          return;
        }
        if (this.highAvailabilityData.configMode === 'DeviceInfo' && this.highAvailabilityData.CenterBindInfoPair.find((item) => !item.isVaild)) {
          return;
        }
        const ips = this.highAvailabilityData.CenterBindInfoPair.map(i => i.ip);
        const ipSet = new Set(ips);
        if (ipSet.size !== ips.length) {
          this.$alert('服务器IP不能相同');
          return;
        }
        this.addMainBackVisible = false;
        this.doSumbitMainBackInfo();
      });
    },
    // 绑定主备设备信息
    confirmBindDeviceConfig() {
      if (this.mainBackMode) {
        this.validateBindMainBackDeviceConfig();
      } else {
        this.validateBindHADeviceConfig();
      }
    },
    doSumbitMainBackInfo() {
      const privateItem = this.bindDevicePrivateItem;
      let params = {
        id: privateItem.id,
        appid: privateItem.appid,
        platform: PLAT_SERVER
      };
      if (this.mainBackMode && this.mainBackData.configMode === 'DeviceFinger') {
        params = {
          ...params,
          hamode: 'false',
          mainip: this.mainBackData.mainip,
          backip: this.mainBackData.backip,
          mainInfoMD5: this.mainBackData.mainMD5,
          backInfoMD5: this.mainBackData.backMD5
        };
      }
      if (this.mainBackMode && this.mainBackData.configMode === 'DeviceInfo') {
        params = {
          ...params,
          hamode: 'false',
          mainip: this.mainBackData.mainip,
          backip: this.mainBackData.backip,
          mainDeviceInfo: this.mainBackData.mainFileValidateResult.file,
          backDeviceInfo: this.mainBackData.backFileValidateResult.file
        };
      }
      if (this.highAvailabilityMode && this.highAvailabilityData.configMode === 'DeviceFinger') {
        params = {
          ...params,
          hamode: 'true',
          haips: this.highAvailabilityData.CenterBindInfoPair.map(i => i.ip),
          hainfomd5s: this.highAvailabilityData.CenterBindInfoPair.map(i => i.md5)
        };
      }
      if (this.highAvailabilityMode && this.highAvailabilityData.configMode === 'DeviceInfo') {
        params = {
          ...params,
          hamode: 'true',
          haips: this.highAvailabilityData.CenterBindInfoPair.map(i => i.ip),
          hainfos: this.highAvailabilityData.CenterBindInfoPair.map(i => i.file)
        };
      }
      const loading = this.loading('绑定设备信息中');
      this.$loader.upload(api.ytprivate.BIND_CENTER, params, undefined, this.ajaxErrorCallback).then(() => {
        loading.close();
        this.$alert('授权成功', null, MessageType.SUCCESS);
        this.cancelBindDeviceInfo(this.mainBackMode ? 'MBMode' : 'HAMode');
        return this.getAllPrivate();
      }).finally(() => {
        this.addMainBackVisible = false;
        loading.close();
        this.cancelBindDeviceInfo(this.mainBackMode ? 'MBMode' : 'HAMode');
      });
    },
    /**
     * 清除表单中上传组件的校验状态
     * @param {*} mode ‘MBMode’ ‘HAMode’
     * @param {*} conf MBMode ‘main’ ‘back’  HAMode ‘0’ ‘1’ ‘2’...
     * @returns undefined
     */
    clearBindDeviceInfoFileVaild(mode, conf) {
      let classItems;
      if (mode === 'MBMode') {
        classItems = this.$refs[`${conf}DeviceInfoFile`].$el.classList;
      } else {
        classItems = this.$refs[`HADeviceInfoFile_${conf}`].$el.classList;
      }
      if (!classItems) {
        return;
      }
      classItems.remove(IS_ERROR);
      classItems.remove(IS_SUCCESS);
    },
    /**
     * 取消手动绑定设备，清除表单输入 & 重置表单验证，并关闭弹窗
     * @param {*} mode ‘MBMode’ ‘HAMode’
     */

    cancelBindDeviceInfo(mode) {
      if (mode === 'MBMode' && this.mainBackData.configMode === 'DeviceInfo') {
        ['main', 'back'].forEach(i => {
          this.clearBindDeviceInfoFileVaild(mode, i);
        });
      }
      if (mode === 'MBMode') {
        this.mainBackData = {
          configMode: 'DeviceInfo',
          mainip: '',
          mainMD5: '',
          mainFileValidateResult: {
            validate: false,
            file: null,
            isVaild: false
          },
          backip: '',
          backMD5: '',
          backFileValidateResult: {
            validate: false,
            file: null,
            isVaild: false
          }
        };
        this.$refs.mainBackData.clearValidate();
      } else {
        this.highAvailabilityData = {
          configMode: 'DeviceInfo',
          CenterBindInfoPair: [
            {
              key: '1',
              ip: '',
              md5: '',
              validate: false,
              file: null,
              isVaild: false
            },
            {
              key: '2',
              ip: '',
              md5: '',
              validate: false,
              file: null,
              isVaild: false
            },
            {
              key: '3',
              ip: '',
              md5: '',
              validate: false,
              file: null,
              isVaild: false
            }
          ]
        };
        this.$refs.highAvailabilityData.clearValidate();
      }
      this.mainBackMode = false;
      this.highAvailabilityMode = false;
      this.addMainBackVisible = false;
    },

    // 绑定设备
    bindDeviceToPrivate(privateItem) {
      this.bindDevicePrivateItem = privateItem;
      this.gpuBindInfo = privateItem.gpubindinfo || [];
      this.svcList = privateItem.stinfo.filter(i => this.productList.find(j => j.property !== 'BODY' && j.id === i.type)).map(i => {
        let rest;
        const found = privateItem.gpubindinfo.find(j => j.productid === i.type);
        rest = found ? found.instancecount * found.gpucount : 0;
        return { ...i, rest };
      });
      if (privateItem.authtype === 2) {
        if (privateItem.is_ha_mode && privateItem.bind_ha_mode) {
          return;
        }
        this.mainBackMode = !privateItem.is_ha_mode;
        this.highAvailabilityMode = !!privateItem.is_ha_mode;
        this.addMainBackVisible = true;
      } else {
        this.addDeviceVisible = true;
        if (this.$refs.addDeviceNoData) {
          this.$refs.addDeviceNoData.resetFields();
          this.deviceShow = true;
          this.deviceInfoShow = false;
          this.deviceGroupShow = false;
          this.deviceFingerprintShow = false;
        }
      }
    },

    confirmBindDevice() {
      this.deviceInfoShow = false;
      this.deviceGroupShow = false;
      this.$refs.addDeviceNoData.validate((valid) => {
        if (!valid) {
          return;
        }
        let privateItem = this.bindDevicePrivateItem;
        let data = {
          id: privateItem.id,
          devno: this.addDeviceNoData.devno,
          platform: KeyEnum.Platform.PLAT_SERVER,
          remark: this.addDeviceNoData.remark
        };
        const loading = this.loading('绑定设备中');
        this.$loader.post(api.ytprivate.BIND_DEVICE, data, this.ajaxErrorCallback).then(() => {
          loading.close();
          this.$alert('设备绑定成功', null, MessageType.SUCCESS);
          return this.getAllPrivate();
        }).finally(() => {
          this.addDeviceVisible = false;
          loading.close();
        });
      });
    },
    // 批量绑定设备
    // bindGroupDeviceToPrivate(privateItem) {
    //   this.groupAddDeviceVisible = true;
    //   this.bindDevicePrivateItem = privateItem;
    //   if (this.$refs.groupAddDeviceValidateData && this.$refs.groupAddDeviceValidateData.value) {
    //     this.$refs.groupAddDeviceValidateData.value = null;
    //   }
    // },

    confirmGroupBindDevice() {
      this.deviceShow = false;
      this.deviceInfoShow = false;
      this.validateFileDevice = !(this.validateFileDevice);
      if (this.validateGroupDeviceFileResult.isVaild === false) {
        return;
      }
      let data = {
        id: this.bindDevicePrivateItem.id
      };
      const loading = this.loading('绑定设备中');
      this.$loader.upload(api.ytprivate.MULTIBIND_DEVICE, data, {file: this.validateGroupDeviceFileResult.file}, this.ajaxErrorCallback).then(() => {
        loading.close();
        this.$alert('设备绑定成功', null, MessageType.SUCCESS);
        return this.getAllPrivate();
      }).finally(() => {
        this.addDeviceVisible = false;
        loading.close();
        this.cancleBindGroupDevice();
      });
    },
    cancleBindGroupDevice() {
      let classItems = this.$refs.deviceGroupFile.$el.classList;
      this.validateFileDevice = false;
      classItems.remove(IS_ERROR);
      classItems.remove(IS_SUCCESS);
      this.groupAddDeviceVisible = false;
      this.$refs.groupAddDeviceValidateData.clearValidate();
      this.validateGroupDeviceFileResult = {
        file: null,
        isVaild: false
      };
    },

    // 绑定设备信息
    confirmBindDeviceInfo() {
      this.deviceShow = false;
      this.deviceGroupShow = false;
      this.validateFileDeviceInfo = !(this.validateFileDeviceInfo);
      if (this.deviceInfoShow) {
        this.$refs.deviceInfoData.validate((valid) => {
          if (!valid || this.validateDeviceInfoFileResult.isVaild === false) {
            return;
          }
          this.doSumbitDeviceInfo();
        });
      }
      if (this.deviceFingerprintShow) {
        this.$refs.addDeviceFingerprintData.validate((valid) => {
          if (!valid) {
            return;
          }
          this.doSumbitDeviceInfo();
        });
      }
    },
    doSumbitDeviceInfo() {
      let privateItem = this.bindDevicePrivateItem;
      let data = {};
      let file = {};
      let tempGpuBindInfo = [];
      if (privateItem.gpubindinfo.length > 0) {
        for (var svc of this.svcList) {
          const gpucount = this.svcListGPU[svc.type];
          const instancecount = this.svcListInstance[svc.type];
          tempGpuBindInfo.push({
            value: `${svc.type},${instancecount},${gpucount}`,
            gpucount,
            instancecount
          });
        }
        for (let it = 0; it < tempGpuBindInfo.length; it++) {
          if ((typeof tempGpuBindInfo[it].instancecount) === 'undefined' || (typeof tempGpuBindInfo[it].gpucount) === 'undefined') {
            return this.$alert('实例数、卡数不能为空', null, MessageType.FAIL);
          }
        }
      }
      const commonData = privateItem.gpubindinfo.length > 0 ? { gpubindinfo: tempGpuBindInfo.map(i => i.value).join('__') } : {};
      if (this.deviceFingerprintShow) {
        data = {
          id: privateItem.id,
          remark: this.addDeviceFingerprintData.remark,
          appid: privateItem.appid,
          ...commonData,
          platform: PLAT_SERVER,
          deviceInfoMD5: this.addDeviceFingerprintData.fingerprint
        };
      }
      if (this.deviceInfoShow) {
        data = {
          id: privateItem.id,
          remark: this.deviceInfoData.remark,
          appid: privateItem.appid,
          ...commonData,
          platform: PLAT_SERVER
        };
        file = {
          deviceInfo: this.validateDeviceInfoFileResult.file
        };
      }
      const loading = this.loading('绑定设备信息中');
      this.$loader.upload(api.ytprivate.BIND_DEVICE_INFO, data, file, this.ajaxErrorCallback).then(() => {
        loading.close();
        this.$alert('授权成功', null, MessageType.SUCCESS);
        return this.getAllPrivate();
      }).finally(() => {
        this.addDeviceVisible = false;
        loading.close();
        this.cancleBindDeviceInfo();
      });
    },

    cancleBindDeviceInfo() {
      let classItems = this.$refs.deviceInfoFile.$el.classList;
      this.validateFileDeviceInfo = false;
      classItems.remove(IS_ERROR);
      classItems.remove(IS_SUCCESS);
      this.deviceInfoData.remark = '';
      this.deviceInfoVisible = false;
      this.$refs.deviceInfoData.clearValidate();
      this.validateDeviceInfoFileResult = {
        file: null,
        isValid: false
      };
    },

    confirmBindDeviceForm() {
      if (this.addMainBackVisible) {
        this.confirmBindDeviceConfig();
        return;
      }
      if (this.deviceShow) {
        this.confirmBindDevice();
        return;
      }
      if (this.deviceGroupShow) {
        this.confirmGroupBindDevice();
        return;
      }
      if (this.deviceInfoShow || this.deviceFingerprintShow) {
        this.confirmBindDeviceInfo();
      }
    },

    cancleBindDeviceForm() {
      if (this.addMainBackVisible) {
        this.cancelBindDeviceInfo(this.mainBackMode ? 'MBMode' : 'HAMode');
        return;
      }
      if (this.deviceGroupShow) {
        this.cancleBindGroupDevice();
      }
      if (this.deviceInfoShow) {
        this.cancleBindDeviceInfo();
      }
      this.addDeviceVisible = false;
      this.deviceShow = true;
      this.deviceGroupShow = false;
      this.deviceInfoShow = false;
      this.deviceInfoVisible = false;
      this.groupAddDeviceVisible = false;
      this.svcListGPU = {};
      this.svcListInstance = {};
    },
    // 申请正式授权
    cancleContractForm() {
      if (this.renewalVisibleFile) {
        let classItems = this.$refs.formalPrivate.$el.classList;
        classItems.remove(IS_ERROR);
        classItems.remove(IS_SUCCESS);
        this.dialogContractFiles = null;
      }
      if (this.renewalVisible) {
        this.$refs.contractForm.resetFields();
      }
      this.contractFormalVisible = false;
      this.validateGroupDeviceFileResultContract = false;
      this.renewalVisible = false;
      this.renewalValidateForm.demand = '';
      this.validateFileContract = false;
      this.renewalVisibleFile = true;
    },
    getAllPrivate() {
      this.$loader.post(api.ytprivate.GET_ALL_YTPRIVATE, {limit: LIST_NUM}, this.ajaxErrorCallback).then(res => {
        this.loaded = true;
        let lists = res.items;
        lists.forEach(item => {
          item.contract = item.contract.split(',');
          item.mailreceiver = item.mailreceiver == null ? item.mailreceiver : item.mailreceiver.replace(/,/g, ';');
          item.ytcontact = item.ytcontact == null ? item.ytcontact : item.ytcontact.replace(/,/g, ';');
          item.optime = DateUtils.format(new Date(item.optime), DateFormat.DEFAULT);
          item.expired = (item.validend - Date.parse(new Date()) < 0);
          item.validbegin = item.validbegin <= 0 ? null : DateUtils.format(new Date(item.validbegin), DateFormat.DEFAULT);
          item.validend = item.validend <= 0 ? null : DateUtils.format(new Date(item.validend), DateFormat.DEFAULT);
          item.deviceStatistics = DeviceUtils.processPrivateBox(item);
          if (item.hardinfo == null) {
            item.hardinfo = [];
          }
          if (item.devices == null) {
            item.devices = [{}, {}, {}, {}, {}];
          }
          let lengthDevice = item.devices.length;
          if (lengthDevice < 5) {
            for (let i = lengthDevice; i < 5; i++) {
              item.devices[i] = {};
            }
          }
          let privateType = [];
          let svcType = [];
          item.stinfo.forEach((it) => {
            if (it.type !== 0) {
              privateType.push(it.name);
              svcType.push(it);
            }
          });
          let privateTypeNum = [];
          let limittype = limittypes[item.limittype];
          let productnum = item.limits;
          for (let it = 0; it < privateType.length; it++) {
            if (productnum[it] && Number(productnum[it]) > 0) {
              privateTypeNum.push(privateType[it].concat('(', limittype, ':', productnum[it], ')'));
            } else {
              privateTypeNum.push(privateType[it]);
            }
          }
          item.svcType = svcType;
          item.svctypeNames = item.authtype === 2 ? privateTypeNum.join('、') : privateType.join('、');
          if (item.privatekey == null || item.privatekey === '') {
            item.privateKeyVisible = false;
          } else {
            item.privateKeyVisible = true;
            item.privateKey = item.privatekey;
          }
        });
        this.privateList = lists;
      });
    },
    openCreatePrivate() {
      if (this.privateList.length >= LIST_NUM) {
        this.$alert('可申请私有云授权数量上限为100，如需继续申请，请删除列表中的部分授权', '申请数量超限', MessageType.FAIL);
      } else {
        this.$router.transfer(RouteKey.OPEN_PRIVATE_CREATOR, {id: this.privateList[0].id});
      }
    },

    // 修改备注
    showUpdateRemarks(id, appid, name, remark) {
      this.remarksVisible = true;
      this.remarksData.appid = appid;
      this.remarksData.devno = name;
      this.remarksData.id = id;
      this.remarksData.remark = remark;
    },
    submitRemarksData() {
      this.$refs.remarksRef.validate((valid) => {
        if (!valid) {
          return;
        }
        const loading = this.loading();
        this.remarksData.remark = this.remarksData.remark.trim();
        this.$loader.post(api.ytprivate.UPDATE_REMARKS, this.remarksData, this.ajaxErrorCallback).then(() => {
          this.resetRemarksData();
          this.getAllPrivate();
        }).finally(() => {
          this.resetRemarksData();
          loading.close();
        });
      });
    },
    resetRemarksData() {
      this.remarksVisible = false;
      this.remarksData.remark = '';
      this.$refs.remarksRef.clearValidate();
    },

    // 下载授权
    downloadCSV(privateItem, deviceItem) {
      let data = {
        id: privateItem.id,
        appid: privateItem.appid,
        platform: deviceItem.platform,
        devno: deviceItem.devno
      };
      let limittype = limittypes[privateItem.limittype] + '_';
      let device = '';
      if (deviceItem.remark && deviceItem.remark.indexOf('主') >= 0) {
        device = '_main.lic';
      } else if (deviceItem.remark && deviceItem.remark.indexOf('备') >= 0) {
        device = '_backup.lic';
      } else {
        device = '';
      }
      let licensename = privateItem.authtype === 2 ? limittype + deviceItem.devno + device : '';
      this.$loader.downloadFileValidate(api.ytprivate.QUERY_LICENSE, data, licensename);
    },
    // 高可用模式下载授权
    downloadHAModeCSV(privateItem) {
      let data = {
        id: privateItem.id,
        appid: privateItem.appid,
        platform: privateItem.devices[0].platform,
        devno: privateItem.devices.map(({ devno }) => devno).filter((devno) => !!devno).join('-')
      };
      let limittype = limittypes[privateItem.limittype] + '_';
      let licensename = privateItem.authtype === 2 ? limittype + '_hamode.lic' : '';
      this.$loader.downloadFileValidate(api.ytprivate.QUERY_LICENSE, data, licensename);
    },
    getAllPrivateType() {
      const loading = this.loading();
      this.$loader.get(api.ytbusiness.QUERY_PRODUCT, null, this.ajaxErrorCallback).then((res) => {
        // let result = res.items;
        const result = res.result.products.filter((item) => {
          return (item.type === SERVICE_TYPE && item.scope === SHOW_SDK_1 && item.online === true);
        });
        this.productList = result;
      }).finally(() => {
        loading.close();
      });
    },

    // 通过密码添加
    openAddDialog() {
      this.addShow = true;
    }
  },
  created() {
    this.ajaxErrorCallback = ErrorHandler.ajaxErrorCallback(this);
    this.getAllPrivateType();
    this.getAllPrivate();
  }
};



// WEBPACK FOOTER //
// ./src/components/open/panels/application/panels/js/PrivateCloudDisplay.js